/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_CancelInputs */

const en_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_audio_embed_export_cancel = /** @type {(inputs: Audio_Embed_Export_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Audio_Embed_Export_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_cancel = /** @type {((inputs?: Audio_Embed_Export_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_cancel(inputs)
	if (locale === "de") return de_audio_embed_export_cancel(inputs)
	if (locale === "it") return it_audio_embed_export_cancel(inputs)
	if (locale === "ru") return ru_audio_embed_export_cancel(inputs)
	if (locale === "es") return es_audio_embed_export_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_cancel(inputs)
	if (locale === "ja") return ja_audio_embed_export_cancel(inputs)
	if (locale === "hi") return hi_audio_embed_export_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_cancel(inputs)
	return en_audio_embed_export_cancel(inputs)
});